/* globals jQuery, console, Cookies, wpAuth0LockGlobal, Auth0Lock, Auth0LockPasswordless */
(function ($) {
  'use strict';
  var state = {
    'redirect_uri':  document.location.href,
  };
  var $doc = $(document);

  if(!$('body').hasClass('logged-in')) {

    var webAuth = new auth0.WebAuth({
      domain:      kwr_auth0.domain,
      clientID:    kwr_auth0.client_id,
      responseType: 'code',
      redirectUri: kwr_auth0.callback,
      state: kwr_auth0.state,
    });

    $doc.on('click', '#login-google', function(e) {
      e.preventDefault();
      webAuth.authorize({
        connection: 'google-oauth2',
      });
    });

    $doc.on('click', '#login-facebook', function(e) {
      e.preventDefault();
      webAuth.authorize({
        connection: 'facebook',
      });
    });

    $doc.on('click', '#login-linkedin', function(e) {
      e.preventDefault();
      webAuth.authorize({
        connection: 'linkedin',
      });
    });
  }

})(jQuery);

